import type { Condition } from '../../hooks/useProductData';
import { getAmountString, humanizeTermRange } from '../humanization';

const approvalProbabilityMap = {
  high: {
    color: 'h-color-G100',
    title: 'Высокое',
  },
  medium: {
    color: 'h-color-O100',
    title: 'Среднее',
  },
  low: {
    color: 'h-color-R100',
    title: 'Низкое',
  },
};

export const getLoanConditions = (item): Condition[] => {
  const conditions = [];

  const { details, approvalProbability } = item;

  const { category } = approvalProbability;

  category &&
    conditions.push({
      value: <span className={approvalProbabilityMap[category].color}>{approvalProbabilityMap[category].title}</span>,
      description: 'Одобрение',
    });

  const maxRange = getAmountString(details.amount.to, details.currency);
  conditions.push({ value: `до ${maxRange}`, description: 'Сумма' });

  const termRange = humanizeTermRange(details.term, {
    termWithUnit: true,
    initialForm: true,
    prepositions: false,
  });

  conditions.push({ value: termRange, description: 'Срок' });

  return conditions;
};
